import { Directive, forwardRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';

import { OrganisationPermissionType } from '@assetaccountant/api/models/organisation-permission-type';
import { AuthorizationService } from '../services/authorization.service';
import { AuthorizeOrganisationBase } from './authorize-organisation.base';
import { AUTHORIZERS } from './authorizer';

@Directive({
  selector: '[authorizeOrganisation]',
  providers: [
    {
      provide: AUTHORIZERS,
      useExisting: forwardRef(() => AuthorizeOrganisationDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class AuthorizeOrganisationDirective extends AuthorizeOrganisationBase {
  @Input('authorizeOrganisation') permission?: OrganisationPermissionType;
  constructor(authorizationService: AuthorizationService, router: Router) {
    super(authorizationService, router);
  }
  protected isAuthorizedForOrganisation(organisationId: number) {
    if (!organisationId) {
      return of(false);
    }

    if (!this.permission) {
      return of(true);
    }

    return this.isAuthorizedForPermission(organisationId, this.permission);
  }
}
